export const PREDICTION_REFETCH_PROCESSING_INTERVAL = 1500;
export const PREDICTION_REFETCH_BASE_SETUP_INTERVAL = 250;
export const PREDICTION_REFETCH_BACKOFF_FACTOR = 1.5;
export const PREDICTION_REFETCH_MAX_INTERVAL = 30000;
export const MS_TO_WAIT_FOR_COLD_BOOT = 1000 * 30;
export const TERMINAL_PREDICTION_STATUSES = ["failed", "succeeded", "canceled"];
